<template>
  <app-layout class="advocay-template">
    <Affix :offset-top="60">
      <Card shadow :padding="10" :style="{borderRadius: '0'}">
        <div class="ivu-input-wrapper ivu-input-type">
          <i class="ivu-icon ivu-icon-search ivu-input-icon ivu-input-icon-normal"></i>
          <input autocomplete="off" spellcheck="false" type="text" placeholder="Search..."
            v-model="filter"
            class="ivu-input">
        </div>
      </Card>
    </Affix>
    <Row type="flex" justify="center">
      <Col :span="24" v-for="(item, k) in orderedSelections" :key="k">
        <ResourceListItemComponent :item="item"></ResourceListItemComponent>
      </Col>
    </Row>
    <!-- <p style="margin-top:10px;color:#aaa;padding:5px 10px">Unpublished Advocacies</p>
    <Row type="flex" justify="center">
      <Col :span="24" v-for="(item, k) in orderedPendingSelections" :key="k">
        <ResourceListItemComponent :item="item"></ResourceListItemComponent>
      </Col>
    </Row> -->
  </app-layout>
</template>

<script>
import _ from 'lodash'
import ResourceListItemComponent from '@/components/ResourceMainAdvocaciesComponent'

export default {
  name: 'AdvocacyComponent',
  components: {
    ResourceListItemComponent
  },
  data() {
    return {
      filter: ''
    }
  },
  computed: {
    userInfo: {
      get() { return this.$store.state.user.info}
    },
    advocacies: {
      get() {
        return this.$store.state.user.advocacies.careplan || []
      }
    },
    pendingAdvocacies: {
      get() {
        return this.$store.state.user.pendingAdvocacies.careplan || []
      }
    },
    orderedSelections: function () {
      var list = this.advocacies.filter((list) => {
        return list.title.toLowerCase().includes(this.filter.toLowerCase());
      });
      return _.orderBy(list,'label');
    },
    orderedPendingSelections: function () {
      var list = this.pendingAdvocacies.filter((list) => {
        return list.title.toLowerCase().includes(this.filter.toLowerCase());
      });
      return _.orderBy(list,'label');
    },
  },
  created() {
    this.$store.dispatch('user/getAdvocacies');
    // this.$store.dispatch('user/getPendingAdvocacies');
  }
}
</script>
